<script lang="ts" context="module">
	const imageModules = import.meta.glob('../assets/*.{.jpg,jpeg,png}', {
		eager: true,
		query: {
			enhanced: true,
			quality: 100,
			lossless: true,
			w: '400;600;800'
		}
	});
	const map = new Map();
	for (const [pathname, module] of Object.entries(imageModules)) {
		map.set(pathname.substring('../assets/'.length, pathname.lastIndexOf('.')), module);
	}
</script>

<script lang="ts">
	export let src: string;
	export let alt: string;
	export let title: string;

	const imageModule = map.get(src);
</script>

<figure class="w-fit mx-auto">
	{#if imageModule}
		<enhanced:img src={imageModule.default} {alt} sizes="(max-width: 600px) 100vw, 600px" />
	{:else}
		<p style:color="red">image not found {src}</p>
	{/if}
	{#if title}
		<figcaption>{title}</figcaption>
	{/if}
</figure>
